<div class="privacy-page inner-page-wrapper">
    <app-sub-nav-legal />
    <main class="py-40 md:py-[80px]">
        <h1 class="mb-24 text-20 leading-25 md:mb-40 md:text-34 md:leading-41">Datenschutz</h1>

        <section>
            <h2>Verantwortlicher und Datenschutzbeauftragter</h2>

            <p>
                Nachfolgend informieren wir Sie über die Verarbeitung Ihrer personenbezogenen Daten im Zusammenhang mit
                Ihrem Besuch auf unserer Händlerwebseite. Personenbezogene Daten sind alle Daten, die auf Sie persönlich
                beziehbar sind, z.B. Name, Adresse, E-Mail-Adressen, Nutzerverhalten, vgl. Art. 4 Nr. 1 DSGVO.
            </p>

            <p>Verantwortlich für die Datenverarbeitung im Rahmen Ihres Besuchs auf dieser Webseite sind</p>

            <h4>{{ dealerName() }}</h4>
            <p>
                {{ dealer().street }}
                <br />
                {{ dealer().zip }} {{ dealer().city }}
                <br />
                E-Mail:
                <a href="mailto:{{ dealer().email }}">
                    {{ dealer().email }}
                </a>
                <br />
                (nachfolgend Vertragshändler genannt)
            </p>

            <p>sowie</p>

            <h4>Hyundai Motor Deutschland GmbH</h4>
            <p>
                Kaiserleipromenade 5,
                <br />
                63067 Offenbach
                <br />
                Telefon: 069 - 380 767 - 101
                <br />

                E-Mail:
                <a href="mailto:info@hyundai.de">info&#64;hyundai.de</a>
            </p>
            <div [editable]="'privacy.dataProtection'">
                @if (privacyContent()) {
                    <span class="custom-format" [innerHTML]="privacyContent().dataProtection"></span>
                }
            </div>

            <div class="mt-32">Den Datenschutzbeauftragten der Hyundai Motor Deutschland GmbH erreichen Sie unter:</div>
            <a href="mailto:datenschutz@hyundai.de">datenschutz&#64;hyundai.de</a>
        </section>

        <section>
            <h2>Datenverarbeitung beim Besuch der Webseite</h2>
            <p>
                Der Vertragshändler bietet Ihnen auf der Webseite verschiedene Services an. Je nachdem, welchen Service
                Sie nutzen, werden dabei verschiedene personenbezogene Daten zu verschiedenen Zwecken verarbeitet.
                Nachfolgend wollen wir Ihnen die Verarbeitung Ihrer Daten näher erläutern.
            </p>
            <div class="ml-48 flex flex-col gap-24">
                <div>
                    <h3>Datenverarbeitung bei Aufruf der Webseite</h3>

                    <p>
                        Diese Händlerwebseite ist eine Unterseite der Top-Level-Domain www.hyundai-partners.de welche
                        von der Hyundai Motor Deutschland GmbH betrieben wird. Für die Inhalte der Händlerwebseite ist
                        jedoch der oben genannte Händler verantwortlich.
                    </p>
                    <p>
                        Um diese Händlerwebseite darstellen zu können, übermittelt Ihr Browser personenbezogene Daten
                        (z.B. IP-Adresse, Datum und Uhrzeit der Anfrage, verwendeter Browser und Betriebssystem) an die
                        Hyundai Motor Deutschland GmbH. Diese Datenverarbeitung ist technisch erforderlich, um Ihnen die
                        Webseite anzuzeigen und die Stabilität und Sicherheit der Webseite zu gewährleisten. Das Hosting
                        der Webseite erfolgt über die Pixelgenau Consulting GmbH, Hanauer Landstr. 151, 60214 Frankfurt
                        am Main, welche wiederum die Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399,
                        USA als Dienstleister für das Hosting einsetzt. Alle Daten, die bei Besuch der Website erhoben
                        werden, werden daher auf den Servern der der Microsoft Corporation in Deutschland gespeichert.
                        Zudem setzt die Pixelgenau Consulting GmbH den Dienst AWS CloudFront der Amazon Webs Services,
                        Inc., 410 Terry Avenue North Seattle, WA 98109, USA ein. AWS CloudFront fungiert als Content
                        Delivery Network (CDN) und dient der schnellen und sicheren Bereitstellung der Inhalte dieser
                        Webseite. Bei Abruf der Inhalte dieser Webseite wird eine Verbindung zu den Servern der Amazon
                        Web Services, Inc. hergestellt, wobei IP-Adresse und ggfs. Browserdaten, wie Ihr User-Agent
                        übermittelt werden. Sowohl Amazon Web Services, Inc. als auch die Microsoft Corporation sind
                        nach dem Data Privacy Framework zertifiziert, eine mögliche Datenübertragung in die USA erfolgt
                        mithin auf Grundlage eines Angemessenheitsbeschlusses nach Art. 45 DSGVO. Die Pixelgenau
                        Consulting GmbH sowie deren Dienstleister agieren als Auftragsverarbeiter und verfahren strikt
                        nach Weisung der Hyundai Motor Deutschland GmbH.
                        <br />
                        Für die Verarbeitung der vorgenannten Daten, ist die Hyundai Motor Deutschland GmbH
                        verantwortlich, ebenso wie für den Einsatz von Webtracking-Diensten, Cookies oder ähnlichen
                        Technologien. Weitere Informationen zur Datenverarbeitung durch die Hyundai Motor Deutschland
                        GmbH bei Aufruf der Webseite finden Sie in der Datenschutzerklärung der Hyundai Motor
                        Deutschland GmbH unter:
                        <a href="https://www.hyundai.com/de/de/datenschutz.html">
                            https://www.hyundai.com/de/de/datenschutz.html
                        </a>
                    </p>
                </div>
                <div>
                    <h3>Terminvereinbarung zur Probefahrt</h3>

                    <p>
                        Nutzen Sie das Kontaktformular zur Vereinbarung einer Probefahrt beim Vertragshändler, erfasst
                        und verarbeitet dieser die folgenden durch Sie angegebenen personenbezogenen Daten:
                    </p>
                    <ol>
                        <li>Anrede</li>
                        <li>Vor- und Nachname</li>
                        <li>Anschrift</li>
                        <li>Telefonnummer</li>
                        <li>ggfs. E-Mail-Adresse</li>
                        <li>Wunschtermin und Wunschfahrzeug zur Probefahrt</li>
                        <li>
                            ggfs. Informationen zu Ihrem Kaufinteresse und geplanter Bezahlung sowie Inzahlunggabe eines
                            Altfahrzeugs
                        </li>
                    </ol>
                    <p>
                        Zweck der Datenverarbeitung ist die Vereinbarung eines Termins zur Probefahrt mit Ihnen. Hierfür
                        wird Sie der Vertragshändler über die von Ihnen angegebenen Kontaktdaten kontaktieren.
                    </p>
                    <p>
                        Rechtsgrundlage der Datenverarbeitung ist Art. 6 Abs. 1 lit. b) DSGVO. Die Datenverarbeitung
                        erfolgt zur Anbahnung und Durchführung eines Vertrages bzgl. der Probefahrt und ggfs. eines
                        Fahrzeugerwerbs.
                    </p>

                    <p>
                        Die Daten werden gelöscht, sobald Ihre Anfrage vollständig bearbeitet wurde und keine anderen
                        Aufbewahrungsfristen (z.B. steuerrechtliche Aufbewahrungsfristen) bestehen und die Daten nicht
                        zur Geltendmachung oder Abwehr von Rechtsansprüchen erforderlich sind.
                    </p>
                </div>
                <div>
                    <h3>Angebotsanfragen</h3>

                    <p>
                        Fragen Sie ein Angebot zu einem der Fahrzeuge des Vertragshändlers an, erfasst und verarbeitet
                        dieser die folgenden durch Sie angegebenen personenbezogenen Daten:
                    </p>
                    <ol>
                        <li>Anrede</li>
                        <li>Vor- und Nachname</li>
                        <li>Anschrift</li>
                        <li>Telefonnummer</li>
                        <li>ggfs. E-Mail-Adresse</li>
                        <li>Adresse</li>
                        <li>Wunschtermin und Wunschfahrzeug zur Probefahrt</li>
                        <li>
                            ggfs. Informationen zu Ihrem Kaufinteresse und geplanter Bezahlung sowie Inzahlunggabe eines
                            Altfahrzeugs
                        </li>
                    </ol>
                    <p>
                        Zweck der Datenverarbeitung ist die Bearbeitung Ihrer Angebotsanfrage. Hierfür wird der
                        Vertragshändler Sie über die von Ihnen angegebenen Kontaktdaten kontaktieren.
                    </p>
                    <p>
                        Rechtsgrundlage der Datenverarbeitung ist Art. 6 Abs. 1 lit. b) DSGVO. Die Datenverarbeitung
                        erfolgt zur Unterbreitung eines Angebots über ein Kraftfahrzeug und damit zur Anbahnung eines
                        Vertragsverhältnisses.
                    </p>
                    <p>
                        Die Daten werden gelöscht, sobald Ihre Anfrage vollständig bearbeitet wurde und keine anderen
                        Aufbewahrungsfristen (z.B. steuerrechtliche Aufbewahrungsfristen) bestehen und die Daten nicht
                        zur Geltendmachung oder Abwehr von Rechtsansprüchen erforderlich sind.
                    </p>
                </div>
                <div>
                    <h3>Allgemeine Anfragen</h3>

                    <p>
                        Kontaktieren Sie den Vertragshändler mit einer allgemeinen Anfrage per E-Mail, erfasst und
                        verarbeitet dieser die personenbezogenen Daten, die Sei in Ihrer E-Mail an uns angeben. Für eine
                        ordnungsgemäße Beantwortung Ihrer Anfrage ist regelmäßig aber zumindest die Verarbeitung der
                        folgenden Daten erforderlich.
                    </p>
                    <ol>
                        <li>Anrede</li>
                        <li>Vor- und Nachname</li>
                        <li>E-Mail-Adresse</li>
                        <li>ggfs. Anschrift</li>
                        <li>ggfs. Telefonnummer</li>
                        <li>ggfs. Fahrzeugdaten, insbesondere Fahrzeug-Identifizierungsnummer</li>
                    </ol>
                    <div>
                        <p>
                            Zweck der Datenverarbeitung ist die Bearbeitung Ihrer Kontaktaufnahme. Hierfür wird Sie der
                            Vertragshändler über die von Ihnen angegebenen Kontaktdaten kontaktieren.
                        </p>
                        <p>
                            Rechtsgrundlage der Datenverarbeitung ist das berechtigte Interesse des Vertragshändlers
                            gemäß Art. 6 Abs. 1 lit. f) DSGVO Kundenfragen zu beantworten. Zielt die Kontaktaufnahme auf
                            die Anbahnung oder den Abschluss eines Vertrages ab, so ist zusätzliche Rechtsgrundlage für
                            die Datenverarbeitung Art. 6 Abs. 1 lit. b) DSGVO.
                        </p>
                        <p>
                            Die Daten werden gelöscht, sobald Ihre Anfrage vollständig bearbeitet wurde und keine
                            anderen Aufbewahrungsfristen (z.B. steuerrechtliche Aufbewahrungsfristen) bestehen und die
                            Daten nicht zur Geltendmachung oder Abwehr von Rechtsansprüchen erforderlich sind.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <h2>Datenverarbeitung zu Werbezwecken</h2>
            <p>
                Sofern Sie dazu eingewilligt haben, werden die nachfolgend aufgeführten Daten durch den Vertragshändler
                zur Prüfung der Service- und Kundenzufriedenheit und zu Werbezwecken sowie durch die Hyundai Motor
                Deutschland GmbH zur Qualitätskontrolle der Hyundai Vertragshändler und zu Marktforschungs- und
                Marketingzwecken verarbeitet:
            </p>
            <ol>
                <li>Anrede</li>
                <li>Vor- und Nachname</li>
                <li>Anschrift</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer</li>
                <li>Adresse</li>
                <li>Konkretes Fahrzeug, das Sie angefragt haben</li>
                <li>ggfs. Informationen zu Ihrem Kaufinteresse und Bezahlung sowie Inzahlunggabe eines Altfahrzeugs</li>
            </ol>

            <p>
                Zweck der Datenverarbeitung ist die werbliche Kontaktaufnahme, die Überprüfung von Service- und
                Kundenzufriedenheit, die Qualitätskontrolle der Hyundai Vertragshändler sowie Marktforschung und
                Marketing.
            </p>
            <p>
                Rechtsgrundlage der Datenverarbeitung ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a) DSGVO. Die
                Erteilung der Einwilligung ist freiwillig und kann von Ihnen jederzeit mit Wirkung für die Zukunft
                widerrufen werden. Kontaktieren Sie hierzu die unter Ziffer 1 genannten Verantwortlichen oder
                Datenschutzbeauftragten.
            </p>
            <p>
                Die im Rahmen der Einwilligung erhaltenen Daten können an externe Dienstleister, die als
                Auftragsverarbeiter für uns tätig sind, übermittelt werden. Diese Dienstleister werden die
                personenbezogenen Daten ausschließlich im Rahmen der von Ihnen erteilten Einwilligung verarbeiten.
            </p>
            <p>
                Die Verarbeitung Ihrer personenbezogenen Daten zu Werbezwecken erfolgt allein so lange, wie Ihre
                Einwilligung hierzu besteht. Mit Erlöschen oder Widerruf der Einwilligung wird die Verarbeitung zu
                Werbezwecken eingestellt und – sofern die Daten nicht auch für einen anderen Zweck (z.B. Anbahnung,
                Abschluss oder Durchführung eines Vertrages) erhoben wurden oder für die Geltendmachung oder Abwehr von
                rechtlichen Ansprüchen erforderlich sind – gelöscht.
            </p>
        </section>
        <section>
            <h2>Weitergabe personenbezogener Daten an Dritte</h2>
            <p>
                Zwischen dem Vertragshändler und der Hyundai Motor Deutschland GmbH erfolgt ein Austausch der erhobenen
                Daten. Der Datenaustausch erfolgt zu den in den Ziffern 2 und 3 genannten Zwecken sowie zur
                Sicherstellung eines einheitlichen und aktuellen Datensatzes beim Vertragshändler und der Hyundai Motor
                Deutschland GmbH.
            </p>
            <p>
                Sollte es in Einzelfällen zur Beantwortung Ihrer Kundenanfrage, z.B. bei der Anfrage von
                Finanzierungsmöglichkeiten, erforderlich sein, können Ihre Daten an Dritte, z.B. die finanzierende Bank
                (Hyundai Capital Bank Europe GmbH, Europa-Allee 22, 60327 Frankfurt am Main), weitergegeben werden.
                Rechtsgrundlage für die Datenweitergabe ist unser berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f)
                DSGVO an der ordnungsgemäßen Bearbeitung Ihrer Kundenanfrage bzw. Art. 6 Abs. 1 lit. b) DSGVO, sofern
                die Weitergabe der Daten der Anbahnung oder dem Abschluss eines Vertrages mit Ihnen dient.
            </p>
            <p>
                Im Rahmen der E-Mail-Kommunikation wird der Simple Email Service von Amazon Web Services, Inc., 410
                Terry Avenue North Seattle WA 98109, USA eingesetzt. Amazon Web Services, Inc. agiert dabei als
                Auftragsverarbeiter. Amazon Webs Services, Inc. ist nach dem Data Privacy Framework zertifiziert, eine
                mögliche Datenübertragung in die USA erfolgt mithin auf Grundlage eines Angemessenheitsbeschlusses nach
                Art. 45 DSGVO.
            </p>
        </section>
        @if (dealer().partsStore) {
            <section>
                <h2>Webshop „Zubehör-Navigator“</h2>
                <p>
                    Sofern auf der Webseite eine Shop-Funktion verfügbar ist, können Sie Bestellungen im Webshop
                    vornehmen. Dieser Service wird Ihnen mittels des Webshops „Zubehör-Navigator“ zur Verfügung
                    gestellt. Bei der Bereitstellung des Webshops unterstützt uns die Hyundai Motor Deutschland GmbH als
                    Auftragsverarbeiter. Diese setzt wiederum selbst die Dr. Schnell & Dr. Hensel GmbH, Stangenland 2,
                    18146 Rostock als Auftragsverarbeiter ein. Diesen Anbieter hat die Hyundai Motor Deutschland GmbH
                    beauftragt, auf der Webseite einen Online-Produktkatalog ggf. inkl. Webshop bereitzustellen. Der
                    Anbieter wurde durch die Hyundai Motor Deutschland GmbH vertraglich an die Einhaltung des
                    Datenschutzes gebunden.
                </p>
                <p>
                    Die Einbindung dieses Service erfolgt durch Platzierung entsprechender Bausteine direkt in der
                    Händlerwebseite. Beim Laden der Bausteine bzw. Aufruf der Landing-Page mit diesen Bausteinen erfolgt
                    technisch bedingt auch ein Aufrufen der Server der Dr. Schnell & Dr. Hensel GmbH. Für die damit
                    verbundene Erhebung und Nutzung der Daten Ihres Browsers und der Verwendung von Cookies verweisen
                    wir auf die Datenschutzerklärung des Anbieters (siehe
                    <a href="https://info.zubehoer-navigator.de/legal.html#datenschutzerklaerung">
                        https://info.zubehoer-navigator.de/legal.html#datenschutzerklaerung
                    </a>
                    ).
                </p>
                <p>
                    Tätigen Sie eine Bestellung im Webshop, werden die im Rahmen des Bestellprozesses erhobenen
                    personenbezogenen Daten verschlüsselt an den Vertragshändler übermittelt und gespeichert. Dieser
                    nutzt die Daten nur zur Abwicklung Ihrer Bestellung und gibt diese dabei auch an am Prozess
                    beteiligte Dienstleister weiter (z.B. an Logistikpartner für die Lieferung oder Kreditinstitute zur
                    Abwicklung des Bezahlvorgangs). Rechtsgrundlage der Datenverarbeitung ist Art. 6 Abs. 1 lit. b)
                    DSGVO.
                </p>
                <p>
                    Der Vertragshändler kann die von Ihnen im Rahmen des Bestellprozesses angegebenen Daten zudem
                    verarbeiten, um Sie über weitere interessante Produkte aus seinem Portfolio zu informieren oder
                    Ihnen E-Mails mit technischen Informationen zukommen lassen, Rechtsgrundlage hierfür ist sein
                    berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f) DSGVO an Direktwerbung gegenüber Bestandskunden.
                </p>
                <p>
                    Der Vertragshändler ist aufgrund handels- und steuerrechtlicher Vorgaben verpflichtet, Ihre Adress-,
                    Zahlungs- und Bestelldaten für die Dauer von zehn Jahren zu speichern. Allerdings wird nach drei
                    Jahren eine Einschränkung der Verarbeitung vorgenommen, d.h. Ihre Daten werden ab diesem Zeitpunkt
                    nur zur Einhaltung der gesetzlichen Verpflichtungen eingesetzt.
                </p>
                <p>
                    Eine Weitergabe Ihrer Daten an Dritte findet grundsätzlich nicht statt. Es erfolgt eine
                    anonymisierte und aggregierte Auswertung über die Nutzung des Webshops „Zubehör-Navigator“. Hierzu
                    wurden Verknüpfungen zu Ihren persönlichen Daten entfernt. Eine darüber hinausgehende Nutzung Ihrer
                    persönlichen Daten erfolgt nicht ohne Ihre ausdrückliche Einwilligung.
                </p>
            </section>
        }
        <section>
            <h2>Wahrnehmung von Betroffenenrechten</h2>
            <p>
                Sie haben gegenüber dem in Ziffer 1 genannten Verantwortlichen die folgenden Rechte hinsichtlich der Sie
                betreffenden personenbezogenen Daten:
            </p>
            <ol class="mt-24">
                <li>
                    <b>Recht auf Auskunft:</b>
                    <span>
                        Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob Ihre personenbezogenen Daten
                        verarbeitet werden. (Art. 15 DSGVO)
                    </span>
                </li>
                <li>
                    <b>Recht auf Berichtigung:</b>
                    <span>
                        Sie haben das Recht, die Berichtigung unrichtiger personenbezogener Daten von Ihnen zu
                        verlangen. (Art. 16 DSGVO)
                    </span>
                </li>
                <li>
                    <b>Recht auf Löschung:</b>
                    <span>
                        Sie haben das Recht, dass Ihre personenbezogenen Daten unverzüglich gelöscht werden, sofern
                        keiner der Ausschlussgründe nach Art. 17 Abs. 1 lit. a) – f) DSGVO vorliegt.
                    </span>
                </li>
                <li>
                    <b>Recht auf Einschränkung der Verarbeitung:</b>
                    <span>
                        Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen, wenn eine der in Art. 18
                        Abs. 1 lit. a) – d) DSGVO geregelten Voraussetzungen gegeben ist.
                    </span>
                </li>
                <li>
                    <b>Recht auf Datenübertragbarkeit:</b>
                    <span>
                        Sie haben das Recht, dass Ihre personenbezogenen Daten an einen Dritten übermittelt werden,
                        sofern einer der in Art. 20 Abs. 1 lit. a) oder b) DSGVO genannten Gründe vorliegt.
                    </span>
                </li>
                <li>
                    <b>Recht auf Widerspruch gegen die Verarbeitung:</b>
                    <span>
                        Sie haben das Recht, jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten, die
                        aufgrund von Art. 6 Abs. 1 lit. e) oder f) DSGVO erfolgt, Widerspruch einzulegen.
                    </span>
                </li>
                <li>
                    <b>Widerrufsrecht:</b>
                    <span>
                        Sie haben das Recht, jederzeit die von Ihnen erteilte Einwilligung zur Verarbeitung Ihrer
                        personenbezogenen Daten zu widerrufen, sofern die Datenverarbeitung auf Ihrer
                        Einwilligungserklärung beruht, vgl. Art. 7 Abs. 3 DSGVO.
                    </span>
                </li>
                <li>
                    <b>Recht auf Beschwerde:</b>
                    <span>
                        Weiterhin haben Sie das Recht, sich gemäß Art. 77 DSGVO bei einer Aufsichtsbehörde zu
                        beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden
                        personenbezogenen Daten durch uns gegen die DSGVO verstößt. Kontaktdaten der Aufsichtsbehörden
                        finden Sie hier:
                        <a href="https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html">
                            https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html
                        </a>
                    </span>
                </li>
            </ol>
        </section>
    </main>
</div>
